var _rect, _rect2, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAddImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 120,
    height: 120,
    rx: 12,
    fill: "white",
    stroke: "#F5F8FE",
    strokeDasharray: "8 8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 41,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F5F8FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2872_228189)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61 53C61.5523 53 62 53.4477 62 54V68C62 68.5523 61.5523 69 61 69C60.4477 69 60 68.5523 60 68V54C60 53.4477 60.4477 53 61 53Z",
    fill: "#C4C7CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53 61C53 60.4477 53.4477 60 54 60H68C68.5523 60 69 60.4477 69 61C69 61.5523 68.5523 62 68 62H54C53.4477 62 53 61.5523 53 61Z",
    fill: "#C4C7CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2872_228189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(49 49)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddImage);
export default __webpack_public_path__ + "static/media/icon_add_image.4c33754ff78b12b5f9bf7024389302d3.svg";
export { ForwardRef as ReactComponent };